import { render, staticRenderFns } from "./Bulletin.vue?vue&type=template&id=134c7b3e&scoped=true"
import script from "./Bulletin.vue?vue&type=script&lang=js"
export * from "./Bulletin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134c7b3e",
  null
  
)

export default component.exports